module.exports = __webpack_public_path__ + "assets/img/pending.01ecb1f9.svg";